import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "m-font-size mb--20" }, "Скачать", -1)
const _hoisted_5 = { class: "items-in-column" }
const _hoisted_6 = ["href"]

import { FileType } from '@/api/house/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveDocsBtn',
  props: {
    docs: {}
  },
  setup(__props: any) {

const props = __props;

const linkHandler = (e: Event) => {
  e.stopPropagation();
};

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_popup = _resolveComponent("base-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.docs.length === 1)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.docs[0].path,
          download: "",
          target: "_blank",
          onClick: linkHandler
        }, [
          _renderSlot(_ctx.$slots, "title"),
          (!_ctx.$slots.title)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                icon: "",
                "style-type": "border",
                withoutActive: ""
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/img/mainPage/icons/icon-pdf.png'),
                    alt: "pdf"
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : (_ctx.docs.length)
        ? (_openBlock(), _createBlock(_component_base_popup, {
            key: 1,
            "with-padding": ""
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (file, i) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: i,
                      href: file.path,
                      class: "underline",
                      download: "",
                      target: "_blank"
                    }, _toDisplayString(file.name), 9, _hoisted_6))
                  }), 128))
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                icon: "",
                "style-type": "border",
                withoutActive: ""
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/img/mainPage/icons/icon-pdf.png'),
                    alt: "pdf"
                  }, null, 8, _hoisted_3)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
  ]))
}
}

})